<template>
  <div class="Main">
    <van-nav-bar
        fixed
        :border="false"
        :title="navBarTitle"
        :left-arrow="$route.name=='user'?false:true"
        :right-text="rightText"
        @click-left="onClickLeft"
        @click-right="onClickRight"
        v-if="$route.name!='user'&&$route.name!='myTask'"
        :style="$route.name=='promote'?'background:transparent':''"
        style="background-color: white;"
    />
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'UserCenter',
  components: {
  },
  props: [],
  data() {
    return {
      rightText: '',
      navBarTitle: '',
    }
  },
  computed: {

  },
  watch: {
    $route(to,from){
      switch(to.name) {
        case 'recharge':
        this.rightText = this.$t('userLc.default[1]');
        break;
      case 'postRecord':
        this.rightText = this.$t('postRecord[1]');
        break;
      case 'newLc':
        this.rightText = this.$t('userLc.default[1]');
        break;
      case 'coins':
        this.rightText = this.$t('home.myCoins');
        break;
      case 'withdraw':
        this.rightText = this.$t('userLc.default[1]');
        break;
        default:
          this.rightText = '';
      }
    }
  },
  created() {
    console.log(this.$route.name)
    switch(this.$route.name) {
       case 'recharge':
         this.rightText = this.$t('userLc.default[1]');
         break;
      case 'postRecord':
        this.rightText = this.$t('postRecord[1]');
        break;
      case 'newLc':
        this.rightText = this.$t('userLc.default[1]');
        break;
      case 'coins':
        this.rightText = this.$t('home.myCoins');
        break;
      case 'withdraw':
        this.rightText = this.$t('userLc.default[1]');
        break;
      default:
        this.rightText = '';
    }
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {

  },
  methods: {
    onClickLeft() {
      switch(this.$route.name) {
        case 'taskRecord':
        case 'postRecord':
        case 'auditRecord':
          this.$router.push('/user')
          break;
        case 'recharge':
          if(this.$children[1].showPrice){
            this.$children[1].showPrice = false
          }else{
            this.$router.go(-1)
          }
          break;
        default:
          this.$router.go(-1)
      }
    },
    onClickRight() {
      if(this.$route.name=='recharge'){
        this.$router.push('/user/wallet')
      }
      if(this.$route.name=='postRecord'){
        this.$router.push('/user/postTask')
      }
      if(this.$route.name=='newLc'){
        this.$router.push('/user/newlist')
      }
      if(this.$route.name=='coins'){
        this.$router.push('/user/coins')
      }
      if(this.$route.name=='withdraw'){
        this.$router.push('/user/wallet/3')
      }
    }
  }
}
</script>
<style lang="scss" scoped>

::v-deep .van-nav-bar__content {
  background: linear-gradient(to right, $theme-shallow-color, $theme-color);
  color: #fff;
}

::v-deep .van-nav-bar__title {
  color: #fff;
}

::v-deep .van-nav-bar .van-icon {
  color: #fff !important;
}
::v-deep .van-nav-bar__text{
	color: #fff;
}
</style>